import type React from 'react';
import { useTranslation } from 'react-i18next';

type ButtonProps = {
  onClick: () => void;
  disabled?: boolean;
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  className?: string;
  isLoading?: boolean;
  type?: 'button' | 'submit' | 'reset';
  // 新增 tabIndex 属性用于控制 tab 顺序
  tabIndex?: number;
};

const tw = (strings: TemplateStringsArray, ...values: unknown[]) =>
  String.raw({ raw: strings }, ...values);

export const Button = ({
  onClick,
  disabled = false,
  children,
  variant = 'primary',
  className = '',
  isLoading = false,
  type = 'button',
  tabIndex,
}: ButtonProps) => {
  const { t } = useTranslation();
  const baseClasses = tw`w-full rounded-[4px] px-[24px] h-[44px] py-[8px] text-[16px] font-medium disabled:opacity-50 disabled:cursor-not-allowed`;

  const variantClasses = {
    primary: tw`bg-[rgb(17,19,20)] text-white hover:enabled:bg-[rgb(17,19,20,.8)] disabled:opacity-50`,
    secondary: tw`border border-solid border-black bg-transparent text-[rgb(17,19,20)] hover:enabled:text-[rgb(17,19,20,.8)] hover:enabled:border-[rgb(0,0,0,.8)]`,
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || isLoading}
      tabIndex={tabIndex}
      className={`${baseClasses} ${variantClasses[variant]} ${className}`}
    >
      {isLoading ? t('components.button.loading') : children}
    </button>
  );
};
